import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import useLenis from "@/hooks/useLenis";
import { BANDS } from "@/data/content";

import { Nav } from "@/components/site/Nav";
import { Hero } from "@/components/site/Hero";
import { Marquee } from "@/components/site/Marquee";
import { Vision } from "@/components/site/Vision";
import { LandBand } from "@/components/site/LandBand";
import { Pillars } from "@/components/site/Pillars";
import { Edition } from "@/components/site/Edition";
import { Voices } from "@/components/site/Voices";
import { TheReport } from "@/components/site/TheReport";
import { Numbers } from "@/components/site/Numbers";
import { Reserve } from "@/components/site/Reserve";
import { Almanac } from "@/components/site/Almanac";
import { Newsletter } from "@/components/site/Newsletter";
import { Footer } from "@/components/site/Footer";

const Home = () => {
  useLenis();
  return (
    <div className="min-h-screen bg-cream">
      <Nav />
      <main>
        <Hero />
        <Marquee tone="forest" />
        <Vision />
        <LandBand {...BANDS.country} />
        <Pillars />
        <Edition />
        <LandBand {...BANDS.soil} />
        <Voices />
        <TheReport />
        <Numbers />
        <LandBand {...BANDS.culture} />
        <Reserve />
        <Almanac />
        <Newsletter />
      </main>
      <Footer />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
